/* eslint-disable */
import React from "react";
import { useNavigate } from "react-router-dom";
import footer_logo from "../../Assests/images/Tip Credit Zone.png";

const index = () => {
  const navigate = useNavigate();

  return (
    <div>
      <section className="footer">
        <div className="container">
          <div className="row footer_bottom_line pb-4">
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="footer_content">
                <img
                  src={footer_logo}
                  className="img-fluid"
                  alt=""
                  onClick={() => navigate("/")}
                />
                <p>
                  Your Partner in Recovering FICA Tip Credits for small
                  businesses.
                </p>
                <p>
                  <i class="fa-regular fa-envelope"></i>
                Michelle@tipcreditzone.com


                </p>
                {/* <p>
                  <i class="fa-solid fa-phone"></i>(123) 456-7890
                </p>
                <p>
                  <i class="fa-solid fa-location-dot"></i>Nationwide Service
                </p> */}
              </div>
            </div>
            <div className="col-lg-3 col-md-12 col-sm-12">
              <h4>Quick Links</h4>
              <p
                style={{ cursor: "pointer" }}
                onClick={() => {
                  navigate("/#howitworks");
                  setTimeout(() => {
                    const el = document.getElementById("howitworks");
                    if (el) el.scrollIntoView({ behavior: "smooth" });
                  }, 300); // delay to allow navigation to finish
                }}
              >
                How It Works
              </p>
              <p
                style={{ cursor: "pointer" }}
                onClick={() => {
                  navigate("/#benefits");
                  setTimeout(() => {
                    const el = document.getElementById("benefits");
                    if (el) el.scrollIntoView({ behavior: "smooth" });
                  }, 300); // delay to allow navigation to finish
                }}
              >
                Benefits
              </p>
              <p
                style={{ cursor: "pointer" }}
                onClick={() => {
                  navigate("/#faqs");
                  setTimeout(() => {
                    const el = document.getElementById("faqs");
                    if (el) el.scrollIntoView({ behavior: "smooth" });
                  }, 300); // delay to allow navigation to finish
                }}
              >
                FAQ
              </p>
            </div>
            <div className="col-lg-3 col-md-12 col-sm-12">
              <h4>Legal</h4>
              <p
                onClick={() => navigate("/privacy-policy")}
                style={{ cursor: "pointer" }}
              >
                Privacy Policy
              </p>
              <p
                onClick={() => navigate("/terms-of-service")}
                style={{ cursor: "pointer" }}
              >
                Terms of Service
              </p>
            </div>
          </div>
          <h6 class="text-center py-4">© 2025 Tip Credit Zone. All rights reserved.</h6>
        </div>
      </section>
    </div>
  );
};

export default index;
